import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({ name: 'isObject' })
export class IsObjectPipe implements PipeTransform {
    transform(value: unknown): boolean {
        return typeof value === 'object' && value !== null;
    }
}
